export function getMetadataByBreakPoint(metadata, breakpoint){
    const replaceDataTableToTable = (content) => {
        _.each(content, (c) => {
            if(c.component && c.component.toLowerCase() == 'datatable') c.component = 'Table';
            if(c.content && Array.isArray(c.content)){
                replaceDataTableToTable(c.content)
            }
        })
    }

    if (breakpoint && breakpoint == 'phone'){
        const _metadata = _.cloneDeep(metadata)
        if( _metadata.pageContent){
            replaceDataTableToTable(_metadata.pageContent.content);
            return _metadata.pageContent
        }
        else if(_metadata.componentContent) {
            replaceDataTableToTable(_metadata.componentContent.content);
            return _metadata.componentContent
        }          
    }

    return metadata.pageContent ||  metadata.componentContent
}